
<div class="cp-share mobile" @click="handleClose">
  <div class="text">
    召集<span class="times">1位</span>兄弟，增加<span class="times">1次</span>抽奖机会
    <!-- 还可以召集<span class="times">{{userInfo.weixin_state ? userInfo.invitablenum : 4}}</span>名兄弟 -->
  </div>
</div>
